export default __webpack_public_path__ + "static/media/home-yoga-meditation-slider-leaves.0e1fa865.png";